import { useState } from "react";

interface AccordionItem {
  q: string;
  a: string;
}

interface AccordionProps {
  items: AccordionItem[];
}

export default function Accordion({ items }: AccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <div className="flex flex-col border-t-2 border-foreground-950">
      {items.map((item, index) => {
        const isOpen = openIndex === index;
        return (
          <div key={item.q} className="border-b-2 border-foreground-950">
            <button
              type="button"
              onClick={() => setOpenIndex(isOpen ? null : index)}
              aria-expanded={isOpen}
              aria-controls={`faq-panel-${index}`}
              className="w-full flex items-center gap-4 px-1 py-5 text-left cursor-pointer"
            >
              <span className="font-label text-[11px] uppercase tracking-[0.18em] text-foreground-500 pt-1">
                {String(index + 1).padStart(2, "0")}
              </span>
              <span className="flex-1 font-heading font-bold uppercase tracking-tight text-base md:text-xl text-foreground-950">
                {item.q}
              </span>
              <span
                className={`w-9 h-9 shrink-0 flex items-center justify-center border-2 border-foreground-950 transition-colors ${
                  isOpen ? "bg-primary-500 text-foreground-950" : "bg-background-50 text-foreground-950"
                }`}
              >
                <i className={isOpen ? "ri-subtract-line text-lg" : "ri-add-line text-lg"}></i>
              </span>
            </button>
            <div
              id={`faq-panel-${index}`}
              aria-hidden={!isOpen}
              className={`grid transition-all duration-300 ease-out ${
                isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
              }`}
            >
              <div className="overflow-hidden">
                <p className="pb-6 pl-9 pr-4 text-sm md:text-base leading-relaxed text-foreground-600">
                  {item.a}
                </p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}